/* Granite Design — theme scripts */
(function () {
  'use strict';
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };

  /* sticky header state */
  var hdr = $('.hdr');
  if (hdr) {
    var stick = function () { hdr.classList.toggle('is-stuck', window.scrollY > 8); };
    stick();
    window.addEventListener('scroll', stick, { passive: true });
  }

  /* mobile nav */
  var burger = $('#Burger'), mnav = $('#MobileNav'), scrim = $('#Scrim');
  function setNav(open) {
    if (!mnav) return;
    mnav.classList.toggle('is-open', open);
    if (scrim) scrim.classList.toggle('is-open', open);
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger) burger.addEventListener('click', function () { setNav(!mnav.classList.contains('is-open')); });
  if (scrim) scrim.addEventListener('click', function () { setNav(false); });
  $$('#MobileNav a').forEach(function (a) { a.addEventListener('click', function () { setNav(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setNav(false); });

  /* toast */
  var toastEl = $('#Toast'), toastT;
  window.gdmToast = function (msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-show');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-show'); }, 3200);
  };

  /* reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* quantity steppers */
  $$('.qty').forEach(function (box) {
    var input = $('input', box);
    if (!input) return;
    $$('button', box).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.step === 'down' ? -1 : 1;
        var min = parseInt(input.min || '1', 10);
        var val = parseInt(input.value || '1', 10) + step;
        input.value = val < min ? min : val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* product gallery */
  var gal = $('[data-gallery]');
  if (gal) {
    var main = $('[data-gallery-main] img', gal);
    $$('[data-gallery-thumb]', gal).forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        var src = t.dataset.full;
        if (src) { main.src = src; main.srcset = ''; }
        $$('[data-gallery-thumb]', gal).forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* variant selection */
  $$('[data-variant-form]').forEach(function (form) {
    var selects = $$('[data-variant-option]', form);
    var idInput = $('[name="id"]', form);
    var priceEl = $('[data-variant-price]');
    var btn = $('[data-add-button]', form);
    var variants = null;
    try { variants = JSON.parse($('[data-variant-json]', form).textContent); } catch (e) { }
    if (!variants || !selects.length) return;

    function update() {
      var chosen = selects.map(function (s) { return s.value; });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl && match.price_formatted) priceEl.innerHTML = match.price_formatted;
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? btn.dataset.labelAvailable : btn.dataset.labelSoldout;
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });

  /* ajax add-to-cart with count refresh */
  $$('[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[type="submit"]', form);
      var old = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = btn.dataset.labelAdding || 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || 'Could not add to cart');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          $$('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? '' : 'none';
            el.classList.remove('is-bump');
            void el.offsetWidth;
            el.classList.add('is-bump');
          });
          window.gdmToast(form.dataset.successMessage || 'Added to cart');
        })
        .catch(function (err) { window.gdmToast(err.message); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = old; } });
    });
  });
})();
